export default "---\nname: Monofilament Rapier\n# owner: HORSE                 # optional: callsign of the pilot holding it\n---\n"